import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import UI from 'stores/ui';
import styles from './style.scss';

const PageMain: FC<{ children: ReactNode }> = ({ children }) => {
    return <div className={classNames(styles.root, UI.isTiger ? styles.inapp : '')}>{children}</div>;
};

export default PageMain;
